module.exports = __webpack_public_path__ + "img/hushed.67ff1cb3.png";